export default __webpack_public_path__ + "static/media/expiryDate5.cefcc214.jpg";